/**
 * ЕДИНСТВЕННОЕ МЕСТО СМЕНЫ БРЕНДОВОГО (АКЦЕНТНОГО) ЦВЕТА ПРОДУКТА.
 *
 * Когда владелец выберет бренд — замените обе 12-ступенчатые шкалы ниже
 * (light и dark) на брендовую палитру и больше ничего не трогайте:
 *  - старая дизайн-система (Tailwind `woot-*`) берёт эти hex при сборке
 *    через theme/colors.js;
 *  - новая (components-next, `n-blue-*`) получает их в рантайме:
 *    themeHelper подставляет значения в CSS-переменные --blue-1..12
 *    для светлой и тёмной тем.
 *
 * Шкалу удобно генерировать по методологии Radix Colors
 * (https://www.radix-ui.com/colors/custom): 1-2 фоны, 3-5 UI-фоны,
 * 6-8 границы, 9-10 сплошной акцент, 11 текст-акцент, 12 контрастный текст.
 *
 * Текущий бренд-акцент — официальный синий #007FFF (решение владельца
 * 2026-07-19): шкала построена по Radix-методологии вокруг него (шаг 9 = #007FFF).
 */

export const brand = {
  1: '#fbfdff',
  2: '#f2f8ff',
  3: '#e4f1ff',
  4: '#d2e7ff',
  5: '#bbdaff',
  6: '#9fcaff',
  7: '#79b3ff',
  8: '#3f92ff',
  9: '#007fff',
  10: '#0074ec',
  11: '#0063cf',
  12: '#0a2e57',
};

export const brandDark = {
  1: '#0a1320',
  2: '#0d1c2e',
  3: '#0f2d4e',
  4: '#103c68',
  5: '#134a7e',
  6: '#175a95',
  7: '#1c6eb3',
  8: '#2286d9',
  9: '#007fff',
  10: '#3a97ff',
  11: '#79b8ff',
  12: '#cfe6ff',
};

const hexToTriplet = hex => {
  const value = hex.replace('#', '');
  const int = parseInt(value, 16);
  // eslint-disable-next-line no-bitwise
  return `${(int >> 16) & 255} ${(int >> 8) & 255} ${int & 255}`;
};

const toTriplets = scale =>
  Object.fromEntries(
    Object.entries(scale).map(([step, hex]) => [step, hexToTriplet(hex)])
  );

// "R G B"-триплеты для CSS-переменных вида rgb(var(--blue-9) / <alpha>)
export const brandTriplets = toTriplets(brand);
export const brandDarkTriplets = toTriplets(brandDark);
